import isNotFalsy from '@atlas/tool/box/isNotFalsy';
import type React from 'react';

export default function combineEventHandlers<
    TEventHandler extends React.EventHandler<React.UIEvent> | React.FocusEventHandler<HTMLElement>,
>(...handlers: Array<TEventHandler | undefined | null>): TEventHandler | undefined {
    const existingHandlers = handlers.filter(isNotFalsy);

    if (existingHandlers.length === 0) return undefined;

    return ((event: Parameters<TEventHandler>[0]) => {
        for (const handler of existingHandlers) {
            if (event.defaultPrevented) break;
            try {
                // Yeah, the onFocus doesn't work with other events, not willing to spend any more time here
                handler(event as any);
            } catch (error) {
                console.error(error);
            }
        }
    }) as TEventHandler;
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('combineEventHandlers', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
